import StepPayment from './stepPayment';

export default StepPayment;
